// extracted by mini-css-extract-plugin
module.exports = {"primary":"#5a00f4","background":"#fafafa","text":"#484f5d","navbarBackground":"#fff","keyboardBackground":"#fff","navbarHeight":"4.25rem"};